// extracted by mini-css-extract-plugin
export default {"clearWrapper":"ClearFilter_clearWrapper__uF089"};